<!--党建引领管理-->
<template>
    <div class="app-container">
        <el-card v-has-btn="'1,2,'" class="mb15">
            <el-row>
                <el-col :span="16" class="mb0">
                    <el-button v-has-btn="'1,2'" @click="handleCreate" type="primary">新增政策法规</el-button>
                </el-col>
            </el-row>
        </el-card>

        <el-card>
            <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="90px"
                     @submit.native.prevent="handleQuery">
                <el-row class="mt15">
                    <el-col :span="6" class="mb0">
                        <el-form-item label="政策类别">
                            <el-select clearable @change="pageList(null)" v-model="queryParams.category" placeholder="请选择">
                                <el-option v-for="item in categoryList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="mb0">
                        <el-form-item label="子类别">
                            <el-select clearable @change="pageList(null)"  v-model="queryParams.subcategory" placeholder="请选择">
                                <el-option v-for="item in subcategoryList" :key="item.value" :label="item.name"
                                           :value="item.value" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" class="mb0"></el-col>
                    <el-col :span="8" class="mr0 mb0">
                        <el-form-item class="pull-right">
                            <el-input v-model="queryParams.title" placeholder="请输入标题" class="input-with-select">
                                <template #append>
                                    <el-button @click="handleQuery" type="primary" icon="el-icon-search" />
                                </template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="bre9e mt15">
                <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                          :height="`calc(100vh - 330px)`"
                          v-loading="loading" :data="dataList" highlight-current-row>
                    <el-table-column type="index" align="center" label="序号" width="60" />
                    <el-table-column width="400" label="标题" align="center" prop="title">
                        <template #default="scope">
                            <div :title="scope.row.title" style="color: #409efe;"
                                 class="text-one cursor">
                                {{ scope.row.title }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="240" label="分类" align="center" prop="categoryName">
                        <template #default="scope">
                            <div :title="scope.row.categoryName"
                                 class="text-one cursor">
                                {{ scope.row.categoryName }} | {{ scope.row.subcategoryName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" label="是否置顶" align="center" prop="isTop">
                        <template #default="scope">
                            <div v-if="scope.row.isTop === 1">是</div>
                            <div v-if="scope.row.isTop === 0">否</div>
                        </template>
                    </el-table-column>
                    <el-table-column width="150" label="发布时间" prop="releaseTime">
                        <template #default="scope">
                            <div>{{ timestampDate(scope.row.releaseTime) }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" width="100" align="center" label="操作"
                                     class-name="small-padding fixed-width">
                        <template #default="scope">
                            <el-popover placement="bottom" trigger="click" :width="80" popper-style="padding: 5px 0 0">
                                <template #reference>
                                    <el-button>操作</el-button>
                                </template>
                                <template #default>
                                    <div>
                                        <div class="text-item" v-if="scope.row.isTop === 0">
                                            <el-text type="primary" @click="handleTop(scope.row)">置顶</el-text>
                                        </div>
                                        <div class="text-item" v-if="scope.row.isTop === 1">
                                            <el-text type="primary" @click="handleTop(scope.row)">取消置顶</el-text>
                                        </div>
                                        <div class="text-item">
                                            <el-text type="primary" @click="handleUpdate(scope.row)">编辑</el-text>
                                        </div>
                                        <div class="text-item">
                                            <el-text type="primary" @click="handleDelete(scope.row)">删除</el-text>
                                        </div>

                                    </div>
                                </template>
                            </el-popover>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="zdyfy">
                <pagination class="zdyfy" :background="false" :pageSizes="[10, 20, 30]" :total="total"
                            :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getList" />
            </div>
        </el-card>


    </div>
</template>
<script>
import { queryDict } from "@/api/admin/public";
import {pageZhengc,deleteZhengc,topZhengc} from "@/api/admin/zhengc"
import {timestampDate} from "@/utils/date";
export default {
    name: "zhengcIndex",
    components: {},
    data() {
        return {
            timestampDate,
            loading: false,
            categoryList:[],
            subcategoryList: [
                { name: '国务院文件', value: 1 },
                { name: '国务院部门文件', value: 2 },
            ],
            dataList:[],
            total:0,
            queryParams:{
                category:'',
                subcategory:'',
                title:'',
                pageNum: 1,
                pageSize: 10,
            }
        };
    },
    created() {
        this.getQueryDict();
        this.pageList();
    },
    activated() {},
    watch: {},
    methods: {
        getQueryDict() {
            queryDict({ code: 'zc_category' }).then(res => {
                this.categoryList = res.data.data;
            })
        },
        changeCategory(){
            this.queryParams.subcategory = '';
            this.categoryList.forEach(j => {
                if (this.queryParams.category === j.dictKey) {
                    this.subcategoryList = j.childrenList;
                }
            })
            this.pageList();
        },
        handleCreate(){
            this.$router.push({
                path: "/zhengcCreate",
            });
        },
        handleUpdate(row){
            this.$router.push({
                path: "/zhengcCreate",
                query: {
                    zhengcId: row.zhengcId,
                }
            });
        },
        handleTop(row){
            topZhengc({ zhengcId: row.zhengcId }).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.pageList(null);
                } else {
                    this.$message.error("操作失败");
                }
            })
        },
        handleDelete(row){
            deleteZhengc({ zhengcId: row.zhengcId }).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.pageList(null);
                } else {
                    this.$message.error("操作失败");
                }
            })
        },
        handleQuery(){
            this.pageList(null);
        },
        pageList(e){
            this.loading = true
            this.dataList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            pageZhengc(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total;
                    this.dataList = JSON.parse(JSON.stringify(res.data.data.list));
                    this.loading = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading = false;
                }
            })
        },
    }
}
</script>

<style scoped>
/deep/ .el-input-group__append {
    background: var(--el-color-primary);
    color: #fff;
}
</style>